import FacebookIcon from 'public/assets/social/icon-facebook.svg'

import encode from '../encodeForShare'

import css from './FacebookShareButton.module.css'

export type FacebookShareButtonProps = {
    title: string
    url: string
}

export default function FacebookShareButton({ title, url }: FacebookShareButtonProps) {
    const facebookShareLink =
        'https://www.facebook.com/sharer.php?' + `title=${encode(title)}&` + `u=${encode(url)}`

    return (
        <a target="_blank" rel="noopener noreferrer" href={facebookShareLink}>
            <FacebookIcon className={css.iconFacebook} />
        </a>
    )
}
